import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndBrandBrief,
  IRemyndBrandPaginateReq
} from "src/apps/modules/remyndBrand/types";
import {
  IRemyndCategoryLv1Brief,
  IRemyndCategoryLv1PaginateReq,
  IRemyndCategoryLv2Brief,
  IRemyndCategoryLv2PaginateReq,
  IRemyndCategoryLv3Brief,
  IRemyndCategoryLv3PaginateReq
} from "src/apps/modules/remyndCategory/types";
import {
  IRemyndProduct,
  IRemyndProductPaginateReq
} from "src/apps/modules/remyndProduct/types";
import {
  IPartnerBrief,
  IPartnerPaginateReq
} from "src/apps/modules/partner/types";
import {
  IPartnerProduct,
  IPartnerProductPaginateReq
} from "src/apps/modules/partnerProduct/types";

const endpoint = "dropdown";

export const listAllRemyndProducts = async (
  search: IRemyndProductPaginateReq
) => {
  return fetchJson<IResponse<IDropdown<IRemyndProduct>[]>>(
    `${endpoint}/remyndProducts`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllRemyndBrands = async (search: IRemyndBrandPaginateReq) => {
  return fetchJson<IResponse<IDropdown<IRemyndBrandBrief>[]>>(
    `${endpoint}/remyndBrands`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllRemyndCatLv1s = async (
  search: IRemyndCategoryLv1PaginateReq
) => {
  return fetchJson<IResponse<IDropdown<IRemyndCategoryLv1Brief>[]>>(
    `${endpoint}/remyndCatLv1s`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllRemyndCatLv2s = async (
  search: IRemyndCategoryLv2PaginateReq
) => {
  return fetchJson<IResponse<IDropdown<IRemyndCategoryLv2Brief>[]>>(
    `${endpoint}/remyndCatLv2s`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllRemyndCatLv3s = async (
  search: IRemyndCategoryLv3PaginateReq
) => {
  return fetchJson<IResponse<IDropdown<IRemyndCategoryLv3Brief>[]>>(
    `${endpoint}/remyndCatLv3s`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllPartners = async (search: IPartnerPaginateReq) => {
  return fetchJson<IResponse<IDropdown<IPartnerBrief>[]>>(
    `${endpoint}/partners`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const listAllPartnerProducts = async (
  search: IPartnerProductPaginateReq
) => {
  return fetchJson<IResponse<IDropdown<IPartnerProduct>[]>>(
    `${endpoint}/partnerProducts`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};
